import React from 'react';
import { GRID_ROW_HEIGHT } from '../utils/defaults';

/**
 * Lignes d’alignement type Figma/Canva pendant le drag.
 * guides: { axis: 'v'|'h', position?: number (0-1), row?: number, kind?: string }[]
 */
export default function AlignmentGuides({ guides = [], gridRows = 1, rowHeight = GRID_ROW_HEIGHT }) {
  if (!guides.length) return null;

  const rowH = rowHeight > 0 ? rowHeight : GRID_ROW_HEIGHT;
  const heightPx = Math.max(1, gridRows) * rowH;

  return (
    <div className="pointer-events-none absolute inset-0 z-[40] overflow-visible" aria-hidden>
      {guides.map((g, i) => {
        if (g.axis === 'v') {
          const leftPct = Math.max(0, Math.min(100, (Number(g.position) || 0) * 100));
          const isCenter = g.kind === 'canvas-center' || g.kind === 'center';
          return (
            <div
              key={`v-${i}-${leftPct}`}
              className="absolute top-0 bottom-0 w-px"
              style={{
                left: `${leftPct}%`,
                background: isCenter
                  ? 'linear-gradient(to bottom, transparent 0%, #ec4899 8%, #ec4899 92%, transparent 100%)'
                  : 'linear-gradient(to bottom, transparent 0%, #38bdf8 8%, #38bdf8 92%, transparent 100%)',
                boxShadow: isCenter
                  ? '0 0 0 0.5px rgba(236,72,153,0.35)'
                  : '0 0 0 0.5px rgba(56,189,248,0.35)',
              }}
            />
          );
        }

        const topPx = Math.max(0, Number(g.row) || 0) * rowH;
        const isCenter = g.kind === 'center';
        return (
          <div
            key={`h-${i}-${topPx}`}
            className="absolute left-0 right-0 h-px"
            style={{
              top: `${Math.min(topPx, heightPx)}px`,
              background: isCenter
                ? 'linear-gradient(to right, transparent 0%, #ec4899 8%, #ec4899 92%, transparent 100%)'
                : 'linear-gradient(to right, transparent 0%, #38bdf8 8%, #38bdf8 92%, transparent 100%)',
              boxShadow: isCenter
                ? '0 0 0 0.5px rgba(236,72,153,0.35)'
                : '0 0 0 0.5px rgba(56,189,248,0.35)',
            }}
          />
        );
      })}
    </div>
  );
}
